<script setup lang="ts">
import { FeeTarget } from '@lib/shared';

// PROPS
interface Props {
    isBuyer: boolean;
}
const { isBuyer } = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();

// DATA
const feeTarget = computed((): FeeTarget => (isBuyer ? FeeTarget.Buyer : FeeTarget.Seller));
</script>

<template>
    <p class="inline-flex gap-1 text-sm">
        <span class="text-dimmed">{{ tt(`fees.simpleNotice.${feeTarget}`) }}</span>
        <SaleFeesInfoModalButton />
    </p>
</template>
